var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCollapseMenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3727 20C23.7189 20 23.9977 19.725 23.9977 19.375L23.9977 18.4875C23.9977 18.1375 23.7189 17.8625 23.3727 17.8625L12.8379 17.8625C12.4929 17.8625 12.2129 18.1375 12.2129 18.4875L12.2129 19.375C12.2129 19.725 12.4929 20 12.8379 20L23.3727 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3759 13.5753C23.7222 13.5753 24.0009 13.2878 24.0009 12.9503L24.0009 12.0503C24.0009 11.7128 23.7222 11.4253 23.3759 11.4253L5.63625 11.4253L7.93246 9.13784C8.17621 8.88785 8.17621 8.48785 7.93246 8.25036L7.30122 7.61287C7.05623 7.37537 6.66123 7.37537 6.41749 7.61287L1.99756 12.0378C1.86882 12.1628 1.80757 12.3378 1.81507 12.5003C1.80757 12.6753 1.86882 12.8503 1.99756 12.9753L6.41749 17.3877C6.66123 17.6377 7.05623 17.6377 7.30122 17.3877L7.93246 16.7627C8.17621 16.5127 8.17621 16.1252 7.93246 15.8752L5.62625 13.5753L23.3759 13.5753Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9977 6.51271C23.9977 6.8627 23.7189 7.1377 23.3727 7.1377L12.8379 7.1377C12.4929 7.1377 12.2129 6.8627 12.2129 6.51271L12.2129 5.62522C12.2129 5.27523 12.4929 5.00023 12.8379 5.00023L23.3727 5.00023C23.7189 5.00023 23.9977 5.27523 23.9977 5.62522L23.9977 6.51271Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCollapseMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/collapse_menu.e3dfde3a68d71ff46af90902ddfe6e24.svg";